import { render, staticRenderFns } from "./ChooseRoleDialog.vue?vue&type=template&id=7b69fa4b&scoped=true&"
import script from "./ChooseRoleDialog.vue?vue&type=script&lang=js&"
export * from "./ChooseRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRoleDialog.vue?vue&type=style&index=0&id=7b69fa4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b69fa4b",
  null
  
)

export default component.exports